






































import { Component, Vue } from 'vue-property-decorator'
import BuilderDescription from '@/components/builder/BuilderDescription.vue'

@Component({
  components: { BuilderDescription },
})
export default class BuilderPreview extends Vue {
  async onNextClick(): Promise<void> {
    console.log(this, 'END!')
  }
}
